import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginUser, passwordReset } from '../../api/auth';

interface PasswordReset {
  onLogin: (email: string, password: string) => void;
  userEmail: string;
}

const PasswordReset: React.FC<PasswordReset> = ({ onLogin, userEmail }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Regex to check for a strong password:
  // - At least 8 characters
  // - At least one uppercase letter
  // - At least one lowercase letter
  // - At least one number
  // - At least one special character from the specified set (@?!$#%)
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@?!$#%]).{8,}$/;

  useEffect(() => {
    setPasswordValid(passwordRegex.test(password));
    setPasswordsMatch(password === confirmPassword && password !== '');
  }, [password, confirmPassword]);

  const handlePasswordReset = async () => {
    if (!passwordValid) {
      console.error('Password does not meet the complexity requirements.');
      return;
    }
    
    if (!passwordsMatch) {
      console.error('Passwords do not match.');
      return;
    }

    try {
      await passwordReset(sessionStorage.userId, password, confirmPassword); // Your password reset logic goes here
      onLogin(userEmail, password);
    } catch (error) {
      console.error('Error resetting password and logging in: ', error);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1 style={{ fontSize: '2em', color: '#4A90E2' }}>Quali-fi</h1>
      </div>
      <h2>Reset Password</h2>
      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />
      {password && !passwordValid && (
        <p style={{ color: 'red', fontSize: '0.9em' }}>
          Password must be at least 8 characters and include:
          <ul>
            <li>One uppercase letter</li>
            <li>One lowercase letter</li>
            <li>One number</li>
            <li>One special character (@?!$#%)</li>
          </ul>
        </p>
      )}
      <input
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />

      {confirmPassword && !passwordsMatch && <p style={{ color: 'red' }}>Passwords do not match!</p>}
      {passwordsMatch && <p style={{ color: 'green' }}>Passwords match!</p>}
      <button
        onClick={handlePasswordReset}
        disabled={!passwordsMatch || !passwordValid}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: (passwordsMatch && passwordValid) ? '#4A90E2' : '#ccc',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: (passwordsMatch && passwordValid) ? 'pointer' : 'not-allowed'
        }}
      >
        Login
      </button>
    </div>
  );
};

export default PasswordReset;